<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.name" placeholder="关键字查询"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="getUsers">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="info" @click="addUser">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" style="width: 90px" v-on:click="getExport">导出Excel</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table :data="infoList" style="width: 100%">
      <!--<el-table-column prop="id" label="id" width="80"></el-table-column>-->
      <el-table-column prop="catalog" label="目录代码" width="120"></el-table-column>
      <el-table-column prop="catalogName" label="目录名称" show-overflow-tooltip width="180"></el-table-column>
      <el-table-column prop="paramCode" label="参数代码" show-overflow-tooltip width="180"></el-table-column>
      <el-table-column prop="paramName" label="参数名称" show-overflow-tooltip width="180"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
      <el-table-column prop="modifyTime" label="更新时间" width="160"></el-table-column>
      <!--第二步  开始进行修改和查询操作-->
      <el-table-column label="操作" align="center" min-width="200">
        <template slot-scope="scope">
          <el-button type="primary" @click="checkDetail(scope.row)">详情</el-button>
          <el-button type="warning" @click="modifyUser(scope.row)">修改</el-button>
          <el-button type="danger" @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" style="text-align: right; padding-right: 19px; padding-top: 7px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageNum"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
    </div>
    <!--新增界面-->
    <el-dialog title="记录" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addFormData" :rules="rules2" ref="addFormData" label-width="150px" class="demo-ruleForm login-container">
        <el-row>
          <el-col>
            <el-form-item prop="catalog" label="选择目录">
              <el-select v-model="addFormData.catalog" @change="changeSelectList" placeholder="参数目录">
                <el-option v-for="item in catalogList" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-show="false">
          <el-col>
            <el-form-item prop="catalogName" label="目录名称">
              <el-input type="text" v-model="addFormData.catalogName" auto-complete="off" placeholder="目录名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="paramCode" label="参数代码">
              <el-input type="text" v-model="addFormData.paramCode" auto-complete="off" placeholder="参数代码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="paramName" label="参数名称">
              <el-input type="text" v-model="addFormData.paramName" auto-complete="off" placeholder="参数名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click.native="dialogVisible = false,addFormData={id:'',typeCode:'',typeName:''}">取 消</el-button>
          <el-button v-if="isView" type="primary" @click.native="addSubmit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
    api
} from '../../api/login';
import axios from 'axios';
import qs from 'qs';
export default {
    name: 'home',
    data() {
        return {
            infoList: [],
            addFormReadOnly: true,
            dialogVisible: false,
            isView: true,
            addFormData: {
              id: '',
              catalog: '',
              catalogName: '',
              paramCode: '',
              paramName: ''
            },
            rules2: {
              catalog: [{required: true,message: '请选择目录',trigger: 'blur'}],
              paramCode: [{required: true,message: '参数编码不能为空',trigger: 'blur'}],
              paramName: [{required: true,message: '参数名称不能为空',trigger: 'blur'}]
            },
            filters: {
                name: ''
            },
            catalogList: [
              {
                code: 'express',
                name: '快递公司'
              },{
                code: 'company',
                name: '商品厂家'
              }
            ],

            cur_page:1,//默认在第一页
            pageNum:10,//默认每页显示1条数据
            totalCount:1 //默认总条数为一条
        }
    },
    mounted: function () {

        this.loadData();
    },
    methods: {
        handleSizeChange(val) {
          this.pageNum=val;//获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
          this.loadData();//展示页面信息
        },
        handleCurrentChange(val) {
          this.cur_page = val;
          this.loadData();//确定当前页面后刷新页面
        },
        loadData() {
            let param = {current:this.cur_page,size:this.pageNum,filter:this.filters.name};
            axios.post('/yogaParam/list', param).then((result) => {
                //console.info(result);
                if(result.data.code == 0){
                    var _data = result.data.data.records;
                    this.infoList = _data;
                    this.cur_page=result.data.data.current;//默认在第一页
                    this.pageNum=result.data.data.size;//默认每页显示1条数据
                    this.totalCount=result.data.data.total;//默认总条数为一条
                }else{
                  this.$message({
                    type: 'error',
                    message: `查询数据失败`
                  });
                }
            });
        },
        getUsers() {
            this.loadData();
        },
        addUser() {
          this.addFormData = {
            id:'',
            catalog:'',
            catalogName:'',
            paramCode:'',
            paramName:''
          };
            this.isView = true;
            this.dialogVisible = true;
        },
        changeSelectList(value){
          let obj = {};
          obj = this.catalogList.find((item)=>{
            return item.code === value;//筛选出匹配数据
          });
          this.addFormData.catalogName = obj.name;

        },
        checkDetail(rowData) {
            this.addFormData = Object.assign({}, rowData);
            this.isView = false;
            this.dialogVisible = true;
        },
        modifyUser(rowData) {
            //this.addFormData = Object.assign({}, rowData);
            this.addFormData = {
              id: rowData.id,
              catalog: rowData.catalog,
              catalogName: rowData.catalogName,
              paramCode: rowData.paramCode,
              paramName: rowData.paramName
            }
            this.isView = true;
            this.dialogVisible = true;
            //    this.addFormReadOnly = false;
        },
        deleteUser(rowData) {
            this.$confirm('是否删除这条记录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              axios.post("/yogaParam/delete?id="+rowData.id).then((result) => {
                //console.info(result);
                if(result.data.code == 0){
                    this.$message({
                      type: 'success',
                      message: '删除成功'
                    });
                  this.loadData();
                }else{
                  this.$message({
                    type: 'error',
                    message: result.data.message
                  });
                }
              });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });
            });
        },
        //增加一条记录
        addSubmit() {
            //先判断表单是否通过了判断
            this.$refs.addFormData.validate((valid) => {
                //代表通过验证 ,将参数传回后台
                if (valid) {
                    let param = Object.assign({}, this.addFormData);
                    axios.post("/yogaParam/submit", param).then((result) => {
                        //alert(result);
                        if (result.data.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '保存成功',
                            });
                            this.loadData();
                        } else {
                            this.$message({
                                type: 'error',
                                message: '保存失败',
                            });
                        }
                        this.dialogVisible = false;
                    });
                }
            });
        },
        getExport(){
          let params = {'catalog':'express','catalog_name':'快递公司'};
          return new Promise((resolve, reject) => {
            axios.get("/yogaParam/export", {
                params: params,
                responseType: "blob" // 1.首先设置responseType对象格式为 blob:
              }).then(
                res => {
                  //resolve(res)
                  let blob = new Blob([res.data], {
                    type: "application/vnd.ms-excel"
                  }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
                  let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
                  // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
                  let a = document.createElement("a");
                  a.href = url;
                  a.download = "导出表格"+Date.parse(new Date())+".xls";
                  a.click();
                  // 5.释放这个临时的对象url
                  window.URL.revokeObjectURL(url);
                },
                err => {
                  resolve(err.response);
                }
              )
              .catch(error => {
                reject(error);
              });
          });
        }

    }

}
</script>



// WEBPACK FOOTER //
// src/components/yoga/YogaParam.vue